import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cloudscale': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M318.1 154L308.7 161.6C286.2 142.3 257.2 128 225.4 128 153.8 128 96 188.8 96 260.3 96 266.9 96.4 273.4 97.4 279.7 95.4 223.7 139.2 182.3 190 182.3 214.2 182.3 236.2 191.7 252.6 207L227.4 227.4C219.1 226.5 210.6 229.2 204.3 235.5 193.2 246.5 193.2 264.4 204.3 275.5 215.4 286.5 233.2 286.5 244.3 275.5 250.6 269.2 253.3 260.6 252.4 252.4L327.6 163.6C333.9 157.1 324.3 147.7 318.1 154zM234.3 265.5C228.7 271 219.7 271 214.1 265.5 208.5 259.9 208.5 250.9 214.1 245.3S228.7 239.7 234.3 245.3 239.9 260 234.3 265.5zM224 32C100.5 32 0 132.5 0 256S100.5 480 224 480 448 379.5 448 256 347.5 32 224 32zM224 416C135.8 416 64 344.2 64 256S135.8 96 224 96 384 167.8 384 256 312.2 416 224 416z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cloudscale.js
// module id = uiep
// module chunks = 144